export const FloatingBoxTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getFloatingBoxBase: () => 'floating-box',
    // for test id generation
    getFloatingBoxTestId: (testId) => [FloatingBoxTestIdFactory.getFloatingBoxBase(), testId].join('-'),
};
